import RefinementCondition, { ever } from 'cio/app-models/conditions/refinement';
import { SECONDS_IN_DAY } from 'cio/utils/constants';

export default function (obj: { refinement: RefinementCondition | null }) {
  let { refinement } = obj;

  if (!refinement) {
    return { times: 1, within: 0 };
  }

  let { times, period, days } = refinement;

  let within = days * SECONDS_IN_DAY;

  if (period === ever) {
    within = 0;
  }

  return { times, within };
}
